import React, { FC } from 'react';
import { Formik } from 'formik';
import { observer } from 'mobx-react';
import { Button, Modal } from 'react-bootstrap';
import { SaveButton } from 'src/libs/ui-kit/buttons/SaveButton';
import { useStore } from 'src/modules/users/hooks/useStore';
import { UserContactsStoreContext } from '../../UserContacts.widget';
import { CreateUserContactForm } from '../forms/CreateUserContactForm';
import { UserContactFormType, UserContactFromInitialValues } from '../../constants';

export const CreateUserContactModal: FC = observer((): JSX.Element => {
  const store = useStore(UserContactsStoreContext);

  return (
    <Formik<UserContactFormType> initialValues={UserContactFromInitialValues} onSubmit={store.createContact}>
      <Modal className="modal-slide" show={store.createModal.isVisible} onHide={store.createModal.hide}>
        <Modal.Header closeButton>
          <Modal.Title as="h5">Создать контакт</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CreateUserContactForm />
        </Modal.Body>
        <Modal.Footer>
          <SaveButton>Сохранить</SaveButton>
          <Button variant="light" onClick={store.createModal.hide}>
            Отменить
          </Button>
        </Modal.Footer>
      </Modal>
    </Formik>
  );
});
